import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { CreateOrEditClientForm } from "./CreateOrEditClientForm";
import { TransformedClientData as Client } from "../../../utils/types";
import { MODAL_CONTENT_SIZING, MODAL_SIZING } from "../../../utils/constants";

interface Props {
    show: boolean;
    onClose: () => void;
    clientData: Client | undefined;
    clientNames: Client[];
    isEdit?: boolean;
}

export const CreateOrEditClientModal: FunctionComponent<Props> = ({ show, onClose, clientData, clientNames, isEdit = false }: Props) => {
    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...MODAL_CONTENT_SIZING }} overflowY="auto">
                <ModalHeader>
                    <span>{clientData?.id ? "Edit" : "Add"}</span> Client
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflowY={"auto"}>
                    <CreateOrEditClientForm onClose={onClose} clientData={clientData} existingClients={clientNames} isEdit={isEdit} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
